export type VerticalValue = string | number | Array<string | number> | null | undefined;

export const formatVerticalList = (value: VerticalValue): string[] => {
  if (value === null || value === undefined) return [];

  if (Array.isArray(value)) {
    return value.map((v) => String(v));
  }


  if (typeof value === 'string') {
    return value
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
  }


  return [String(value)];
};
